window.dataLayer = window.dataLayer || [];
function gtag() {
	// eslint-disable-next-line prefer-rest-params
	window.dataLayer.push(arguments);
}

gtag("consent", "default", {
	ad_storage: "denied",
	ad_user_data: "denied",
	ad_personalization: "denied",
	analytics_storage: "denied",
	personalization_storage: "denied",
	wait_for_update: 2000,
});
